import { __assign } from '../../../_virtual/_tslib.js';
import * as React from 'react';
import { IconWrapper } from '../../../components/icon-wrapper.js';

var SvgFeatherRibbon = React.forwardRef(function SvgFeatherRibbon(props, ref) {
    return (React.createElement(IconWrapper, __assign({ ref: ref }, props), React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22" }),
        React.createElement("path", { d: "m12 18 2.57-3.5" }),
        React.createElement("path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009" }),
        React.createElement("path", { d: "M9.35 14.53 12 11.22" }),
        React.createElement("path", { d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z" }))));
});

export { SvgFeatherRibbon as default };
